import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSession } from '@/api/portal';
import Sidebar from './Sidebar';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const pageTitles: Record<string, { title: string; subtitle: string }> = {
  '/dashboard': { title: '仪表盘', subtitle: '交易概览与关键指标' },
  '/transactions': { title: '交易记录', subtitle: '查询订单、状态和通道流水' },
  '/channels': { title: '通道列表', subtitle: '查看可用支付通道、支付方式和商户费率' },
  '/settings': { title: '商户配置', subtitle: '维护回调地址和联系人信息' },
  '/api-docs': { title: 'API 文档', subtitle: '下单、查单、签名和通知说明' },
  '/withdraw': { title: '结算提现', subtitle: '查看可结算金额和提现说明' },
  '/payment-accounts': { title: '提现账号', subtitle: '管理银行卡、支付宝、微信、USDT 提现账号' },
  '/merchant-keys': { title: '应用密钥', subtitle: '查看密钥并配置 IP 白名单' },
};

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const session = getSession();
  const pageInfo = pageTitles[location.pathname] ?? { title: '商户门户', subtitle: '' };

  useEffect(() => {
    if (!session) navigate('/login', { replace: true });
  }, [navigate, session]);

  if (!session) return null;

  return (
    <div className="min-h-screen bg-slate-900">
      <Sidebar />
      <div className="lg:ml-60 min-h-screen flex flex-col">
        <header className="sticky top-0 z-30 h-16 px-6 flex items-center justify-between border-b border-slate-700/60 bg-slate-900/80 backdrop-blur-md">
          <div className="min-w-0 pl-12 lg:pl-0">
            <p className="text-xs text-slate-500 truncate">{pageInfo.subtitle}</p>
            <h2 className="text-base font-bold text-slate-100 mt-0.5">{pageInfo.title}</h2>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-xs text-slate-500 bg-slate-800/60 rounded-lg px-3 py-1.5 border border-slate-700/50">
            <span className="font-mono text-slate-300">{session.appId}</span>
          </div>
        </header>
        <main className="flex-1 px-4 md:px-6 py-6 max-w-7xl mx-auto w-full">{children}</main>
      </div>
    </div>
  );
}
